<div id="approach" class="container">
    <div class="section-title" *ngFor="let sectionTitleContent of sectionTitle;">
        <span class="sub-title"><img src="https://imgvid.blob.core.windows.net/imgvid/star-icon.png" alt="image"> {{sectionTitleContent.subTitle}}</span>
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}} </p>
    </div>

    <div class="row">
        <div class="col-lg-4 col-md-6" *ngFor="let processBoxContent of singleProcessBox;">
            <div class="single-process-box">
                <div class="number">{{processBoxContent.number}}</div>
                <!-- <div class="image">
                    <img [src]="processBoxContent.img" alt="image">
                </div> -->
                <h3>{{processBoxContent.title}}</h3>
                <p>{{processBoxContent.paragraphText}}</p>
            </div>
        </div>
    </div>

    <div class="section-title" *ngFor="let sectionTitleContent of sectionTitle;" style="padding-top: 20px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/python.png" alt="image" width="50px" style="margin-right: 30px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/opencv.png" alt="image" width="50px" style="margin-right: 30px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/tensorflow.png" alt="image" width="45px" style="margin-right: 30px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/pytorch.png" alt="image" width="45px" style="margin-right: 20px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/yolo.png" alt="image" width="150px" style="margin-right: 20px;">
        <img src="https://imgvid.blob.core.windows.net/imgvid/hf.png" alt="image" width="60px">
    </div>
</div>
<div class="process-area">
    <hr/>
</div>